import { gql } from '@apollo/client';

//Cash receipt from customers
const queryReportsPayments = gql`
  query ReportsPayments($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    payments(currency: $currency, byProject: false, freq: $freq) {
      amount
      currency
      project
      period
    }
  }
`;
//My Awesome Project, The Biggest Client, My Friend's Project
const queryReportsPaymentsByPrj = gql`
  query ReportsPaymentsByPrj($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    payments(currency: $currency, byProject: true, freq: $freq) {
      amount
      currency
      project
      period
    }
  }
`;

//Wages and salaries
const queryWagesSalaries = gql`
  query WagesSalaries($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Wages and salaries (byProject)
const queryWagesSalariesByProject = gql`
  query WagesSalariesByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, byProject: true, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Wages and salaries (byEmployee)
const queryWagesSalariesByEmployee = gql`
  query WagesSalariesByEmployee($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, byProject: true, byEmployee: true, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Administrative personnel
const queryWagesSalariesAdmin = gql`
  query WagesSalariesAdmin($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: ADMIN) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Employees assigned to the projects
const queryWagesSalariesAssigned = gql`
  query WagesSalariesAssigned($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: ASSIGNED) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Employees on bench
const queryWagesSalariesNotAssigned = gql`
  query WagesSalariesNotAssigned($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: NOT_ASSIGNED) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses
const queryExpenses = gql`
  query Expenses($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, reasonType: OPERATIONAL, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses byProject
const queryExpensesByProject = gql`
  query ExpensesByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, byProject: true, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses by category
const queryExpensesByCategory = gql`
  query ExpensesByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, reasonType: OPERATIONAL, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses byProject by category
const queryExpensesByPC = gql`
  query ExpensesByPC($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, freq: $freq, byProject: true, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Extra Income
const queryExtraIncome = gql`
  query ExtraIncome($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    extraIncome(currency: $currency, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Extra Income by category
const queryExtraIncomeByCategory = gql`
  query ExtraIncomeByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    extraIncome(currency: $currency, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Investments
const queryInvestments = gql`
  query Investments($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: INVESTMENTS, currency: $currency, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Investments by category
const queryInvestmentsByCategory = gql`
  query InvestmentsByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: INVESTMENTS, currency: $currency, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Distributions
const queryDistributions = gql`
  query Distributions($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: DISTRIBUTION, currency: $currency, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Distributions by category
const queryDistributionsByCategory = gql`
  query DistributionsByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: DISTRIBUTION, currency: $currency, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Taxes paid
const queryTaxes = gql`
  query Taxes($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: TAX, currency: $currency, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Taxes paid by category
const queryTaxesByCategory = gql`
  query TaxesByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(reasonType: TAX, currency: $currency, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Actual ending cash balance
const queryBalances = gql`
  query Balances($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    balances(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Balance changes
const queryBalanceChanges = gql`
  query BalanceChanges($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    balanceChanges(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Discrepancy
const queryDiscrepancy = gql`
  query Discrepancy($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    discrepancy(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Exchange operations
const queryExchangeOperations = gql`
  query ExchangeTransactions($freq: FrequencyEnum) @api(name: reporting) {
    exchangeTransactions(freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Net cash flow
const queryNetCashFlow = gql`
  query NetCashFlow($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    cashFlow(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Net cash flow by Project
const queryNetCashFlowByProject = gql`
  query NetCashFlowByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    cashFlow(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

export {
  queryReportsPayments,
  queryReportsPaymentsByPrj,
  queryWagesSalaries,
  queryWagesSalariesByProject,
  queryWagesSalariesByEmployee,
  queryWagesSalariesAdmin,
  queryWagesSalariesAssigned,
  queryWagesSalariesNotAssigned,
  queryExpenses,
  queryExpensesByProject,
  queryExpensesByCategory,
  queryExpensesByPC,
  queryExtraIncome,
  queryExtraIncomeByCategory,
  queryInvestments,
  queryInvestmentsByCategory,
  queryDistributions,
  queryDistributionsByCategory,
  queryTaxes,
  queryTaxesByCategory,
  queryBalances,
  queryBalanceChanges,
  queryDiscrepancy,
  queryNetCashFlow,
  queryNetCashFlowByProject,
  queryExchangeOperations,
};
